import { registerComponent } from '@gig/magic-common';
import TimeOutComponent from './time-out.vue.js';

var TimeOut = registerComponent(TimeOutComponent);

export { TimeOut };
